document.addEventListener("DOMContentLoaded", (e) => {
  const bisSignupModal = document.querySelector("#bis-signup-modal");

  const bisSuccessModal = document.querySelector("#bis-success-modal");

  const bisSignupForm = bisSignupModal.querySelector("#bis-signup-form");

  const messagebox = bisSignupModal.querySelector("#messagebox");

  bisSignupForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const email = bisSignupForm.querySelector("#email").value;
    const variantInputs = bisSignupForm.querySelectorAll(".bis-variant");
    let variantChecks;

    if (variantInputs.length > 1) {
      variantChecks = Array.from(bisSignupForm.querySelectorAll(".bis-variant-check")).map(
        (input) => input.checked
      );
    } else {
      variantChecks = [true];
    }

    const variantsToSend = [];
    variantInputs.forEach((input, index) => {
      if (variantChecks[index]) {
        variantsToSend.push(input.value);
      }
    });

    if (variantsToSend.length == 0) {
      messagebox.classList.remove("jc-hidden");

      return;
    } else {
      messagebox.classList.add("jc-hidden");
    }

    const promises = [];
    variantsToSend.forEach((variant, index) => {
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-05-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variant}`,
                },
              },
            },
          },
        }),
      };

      promises.push(
        new Promise((resolve, reject) => {
          setTimeout(() => {
            fetch(
              "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WMA94z",
              options
            ).then((response) => {
              if (response.ok) {
                resolve(response);
              } else {
                reject(response);
              }
            });
          }, 2000 * index);
        })
      );

      Promise.any(promises)
        .then((result) => {
          bisSignupModal.close();
          bisSuccessModal.open();
        })
        .catch((error) => error);
    });
  });
});
